<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="natureMarche.intitule"

	[label]="step3.champIntitule"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000|required'"
	[errorMessage]="{'required' : 'ctr_1090_HorsDef', 'maxLength' : 'ctr_1091_HorsDef'}"
	[name]="getUid() + '_SepAtt_intitule'"
>
</app-form-input>

<app-type-objCPV
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[codeCPV]="natureMarche.codeCPV"
></app-type-objCPV>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="natureMarche.description"

	[label]="step3.description"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_description'"
>
</app-form-input>

<!---->

<app-type-nature-marche-choix
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[natureMarche]="natureMarche.natureMarche"
></app-type-nature-marche-choix>

<app-form-input
	[disabled]="disabled"
	[parentForm]="parentForm"
	[value]="natureMarche.lieuExecution"
	[label]="step3.getspan20"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000|required'"
	[errorMessage]="{'required' : 'ctr_176'}"
	[name]="getUid() + '_SepAtt_lieuExecution'"
></app-form-input>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="natureMarche.dureeMois"

	[label]="step3.dureeMois"
	[type]="'number'"
	[rule]="'min_0|max_999'"
	[name]="getUid() + '_SepAtt_dureeMois'"
>
</app-form-input>

<!---->

<app-type-montant-fourchette
	[valeurEstimee]="natureMarche.valeurEstimee"
	[parentForm]="parentForm"
	[disabled]="disabled"

	[uid]="getUid()"
></app-type-montant-fourchette>

<!---->

<app-type-oui-non
	[uid]="getUidTranches()"
	[parentForm]="parentForm"
	[label]="step3.getspan21"
	[disabled]="disabled"
	[value]="natureMarche.tranches"
></app-type-oui-non>

<!---->

<app-type-oui-non-reservation-marche
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[reservationMarche]="natureMarche.reservationMarche"
></app-type-oui-non-reservation-marche>
